export interface FaqItem {
  question: string
  answer: string
}

export interface FaqCategory {
  label: string
  value: string
  items: FaqItem[]
}

export const FAQ_CATEGORIES: FaqCategory[] = [
  {
    label: 'Shipping & Delivery',
    value: 'shipping',
    items: [
      {
        question: 'How far in advance should I ship my bags?',
        answer:
          'We recommend shipping your bags at least 3–5 business days before your departure date. Express and overnight options are also available for last-minute needs.',
      },
      {
        question: 'How do I track my shipment?',
        answer:
          'Once your bags are picked up, you will receive a tracking number via email. You can use this number to track your shipment in real time on our website or through the carrier\u2019s tracking page.',
      },
      {
        question: 'What happens if my bags arrive late?',
        answer:
          'In the rare event of a delay, our team will work directly with the carrier to expedite delivery. If your bags do not arrive by the guaranteed date, you may be eligible for a refund of shipping fees.',
      },
      {
        question: 'Can I ship to an international destination?',
        answer:
          'Yes, we offer international shipping to many destinations. Additional customs and duties fees may apply depending on the destination country.',
      },
    ],
  },
  {
    label: 'Bags & Items',
    value: 'bags',
    items: [
      {
        question: 'What items can I ship?',
        answer:
          'You can ship luggage, golf clubs, ski and snowboard equipment, bikes, boxes, and other sporting equipment. Prohibited items include hazardous materials, perishable goods, and items exceeding size/weight limits.',
      },
      {
        question: 'What are the size and weight limits?',
        answer:
          'Standard bags can weigh up to 50 lbs. Oversized items such as golf clubs, skis, and bikes have specific size guidelines. Check the item details during booking for exact limits.',
      },
      {
        question: 'How should I pack my bags?',
        answer:
          'Use sturdy luggage or hard-sided cases when possible. Remove any old shipping labels, and make sure all zippers and clasps are secured. Fragile items should be wrapped and cushioned.',
      },
    ],
  },
  {
    label: 'Pickup & Drop-off',
    value: 'pickup',
    items: [
      {
        question: 'How does pickup work?',
        answer:
          'After you complete your booking, a carrier will pick up your bags at the specified address and time window. You\u2019ll receive a confirmation email with your pickup details.',
      },
      {
        question: 'Can I drop off my bags instead of scheduling a pickup?',
        answer:
          'Yes, drop-off locations are available in many areas. During booking, you can choose a drop-off option if one is available near your address.',
      },
      {
        question: 'What if I need to reschedule my pickup?',
        answer:
          'You can reschedule your pickup by contacting our support team at least 24 hours before the scheduled time. Changes may be subject to availability.',
      },
    ],
  },
  {
    label: 'Pricing & Payment',
    value: 'pricing',
    items: [
      {
        question: 'How is pricing determined?',
        answer:
          'Pricing is based on the type of item, weight, service level (standard, express, or overnight), and the origin and destination addresses.',
      },
      {
        question: 'What payment methods do you accept?',
        answer:
          'We accept all major credit cards (Visa, Mastercard, American Express, Discover) as well as digital wallets like Apple Pay and Google Pay.',
      },
      {
        question: 'Can I get a refund if I cancel my order?',
        answer:
          'Cancellations made before pickup are eligible for a full refund. Once your bags have been picked up, cancellation and refund policies vary based on the shipping status.',
      },
    ],
  },
  {
    label: 'Insurance & Protection',
    value: 'insurance',
    items: [
      {
        question: 'Is my shipment insured?',
        answer:
          'All shipments include basic carrier liability coverage. For additional protection, you can purchase supplemental insurance during checkout to cover the full declared value of your items.',
      },
      {
        question: 'How do I file a claim for lost or damaged items?',
        answer:
          'Contact our support team within 30 days of delivery. We\u2019ll guide you through the claims process and work to resolve the issue as quickly as possible.',
      },
    ],
  },
  {
    label: 'Cruise Shipping',
    value: 'cruise',
    items: [
      {
        question: 'Can I ship my bags directly to a cruise port?',
        answer:
          'Yes! We deliver directly to major cruise ports. Your bags will be waiting for you when you board. Just provide your cruise line, ship name, and sail date during booking.',
      },
      {
        question: 'When should I ship my bags for a cruise?',
        answer:
          'We recommend shipping at least 5–7 business days before your sail date to allow time for port processing and delivery to your ship.',
      },
      {
        question: 'Can I ship bags home from the cruise port after my trip?',
        answer:
          'Absolutely. You can schedule a return shipment from the cruise port to your home address. Set up your return booking before your cruise ends for a seamless experience.',
      },
    ],
  },
]

export const ALL_CATEGORIES_VALUE = 'all'
